<div class="green-banner d-flex flex-column justify-content-center align-items-center text-center mb-6">
  <h1 class="display-3 text-white m-0 p-0" [ngClass]="{ 'mb-0': !subTitle }">{{ title }}</h1>
  <h4 class="text-white m-0 p-0" *ngIf="subTitle">{{ subTitle }}</h4>
</div>
